import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Container,
  Alert,
  Card,
  Form,
  Col,
  Badge,
  Modal,
} from "react-bootstrap";

function Product({ product, updatecredit, currentcredit }) {
  const [paidFor, setPaidFor] = useState(false);
  const [error, setError] = useState(null);
  const paypalRef = useRef();

  useEffect(() => {
    window.paypal
      .Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                description: product.description,
                amount: {
                  currency_code: "USD",
                  value: product.price,
                },
              },
            ],
          });
        },
        onApprove: async (data, actions) => {
          const order = await actions.order.capture();
          setPaidFor(true);
          console.log(order);
          console.log("new credit:", currentcredit + product.price);
          updatecredit(parseFloat(currentcredit) + parseFloat(product.price));
        },
        onError: (err) => {
          setError(err);
          console.error(err);
        },
      })
      .render(paypalRef.current);
  }, [product.description, product.price]);

  if (paidFor) {
    return (
      <div>
        <Alert variant="success">
          Congrats, you just bought ${product.name}!
        </Alert>
      </div>
    );
  }
  return (
    <div>
      {error && <div>Uh oh, an error occurred! {error.message}</div>}
      {product.description} for ${product.price}
      <div ref={paypalRef} />
    </div>
  );
}
export default Product;
